var _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocationDark = function SvgLocationDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "43px",
    viewBox: "0 0 25 43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Appointments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dekstop-\\u2013-Select-Clinic-Location",
    transform: "translate(-551.000000, -319.000000)",
    fill: "#4B4E68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location",
    transform: "translate(525.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selected-Location-Icon",
    transform: "translate(26.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4227266,42.3895631 L23.18602,19.1969028 L23.1886508,19.1910387 L23.7503114,17.8325137 C23.7647805,17.7953741 23.7772764,17.7588862 23.7831956,17.7223982 C26.0015579,13.119051 25.1866895,7.43930887 21.3385905,3.6269685 C16.4572726,-1.2089895 8.54403945,-1.2089895 3.66206388,3.6269685 C-0.158412479,7.41129133 -0.98972288,13.0343468 1.16879036,17.6201016 C1.17405182,17.6396487 1.17931328,17.6591959 1.18786315,17.6780914 L1.62193345,18.7551378 L1.62785259,18.7688208 L11.5772701,42.3895631 C11.7910169,42.895182 12.3756964,43.1336569 12.8860579,42.9238511 C13.1280849,42.8222061 13.3214435,42.6306443 13.4227266,42.3895631 M16.036356,8.88123491 C17.9896724,10.8157484 17.9896724,13.9517584 16.036356,15.8869235 C14.0830396,17.8207854 10.9162994,17.8207854 8.96429842,15.8869235 C7.01098205,13.9517584 7.01098205,10.8157484 8.96429842,8.88123491 C10.9162994,6.94541826 14.0830396,6.94541826 16.036356,8.88123491",
    id: "Location-Icon"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-dark.9f0d841d.svg";
export { ForwardRef as ReactComponent };